import { ExperimentPage } from '~/cf-worker/types';
import { PAID_PROGRAM_PLP_PATH_REGEX } from '~/features/experiments/price-card-ab-test-2026/paid-program-path-regex';

export const experimentedPages: ExperimentPage[] = [
  {
    experimentKey: 'school_lp_redesign',
    name: 'School Landing Page Redesign Feature Flag',
    // Note: as of 5/1/2025, we will only run the new school landing page on non-legacy school lps.
    // Once we have the content ready for the legacy school lps, we can update this regex to include all school lps.
    pathRegex:
      /^\/school\/(?!data-science|business|programming|artificial-intelligence|cybersecurity|product-management|executive-leadership|autonomous-systems|animation-and-game-development|cloud-computing|devops|career-resources$).+$/,
    type: 'flag',
  },
  {
    experimentKey: 'masters_lp_hero_takeover',
    name: 'MSAI/MBA Hero Takeover',
    pathRegex: /^\/(masters-artificial-intelligence|mba-ai-product-management)$/,
    type: 'flag',
    options: { expiresAt: '2026-10-08T23:59:59-07:00' }, // October Flash 2026 final phase ends Oct 8 2026, 23:59:59 PT
  },
  {
    experimentKey: 'masters_lp_region_block',
    name: 'MSAI/MBA Region Block',
    pathRegex: /^\/(masters-artificial-intelligence|mba-ai-product-management|recognition-of-prior-learning)$/,
    type: 'flag',
  },
  {
    experimentKey: 'claude-engineer-2026',
    name: 'Claude Engineer 2026',
    pathRegex: /^\/(|experience)$/,
    type: 'flag',
  },
  {
    experimentKey: 'agentic-ai-2026',
    name: 'Agentic AI 2026',
    pathRegex: /^\/$/,
    type: 'flag',
  },
  {
    experimentKey: 'price-card-ab-test-2026',
    name: 'Price Card A/B/C Test 2026',
    pathRegex: PAID_PROGRAM_PLP_PATH_REGEX,
    type: 'experiment',
  },
  {
    experimentKey: 'catalog_search_improvements',
    name: 'Catalog Search Improvements Phase 1',
    pathRegex: /^\/catalog$/,
    type: 'experiment',
  },
];
